<template>
    <div v-if="!isLoading" class="EntityDetailsShifts">
        <ShiftsTable :shifts="shifts" :show-all-trips="false" :container-height="'400px'" />
    </div>
</template>

<script>
import ShiftsTable from '@/views/Dashboard/Shifts/components/ShiftsTable.vue';

export default {
    name: 'EntityDetailsShifts',
    components: {
        ShiftsTable,
    },
    props: {
        shifts: {
            type: Array,
            default: () => [],
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.EntityDetailsShifts {
    margin-bottom: 24px;

    .shifts-title {
        font-size: 14px;
        font-weight: 600;
        color: var(--color-text-black, #1a1a1a);
        margin: 0 0 16px 0;
    }
}
</style>
